import { getCookieToken } from '@/libs/cookies'
import { UPDATE_ADDRESS, fetchWithToken } from '@/services'

export const UPDATE_CUSTOMER_ADDRESS = `
  mutation updateCustomAddress($id: Int!, $input: CustomerAddressInput) {
    updateCustomerAddress(id: $id, input: $input) {
      city
      company
      country_code
      country_id
      custom_attributes {
        ...CustomerAddressAttributeFields
      }
      customer_id
      default_billing
      default_shipping
      extension_attributes {
        ...CustomerAddressAttributeFields
      }
      fax
      firstname
      id
      lastname
      middlename
      postcode
      prefix
      region {
        region
        region_code
        region_id
      }
      region_id
      street
      suffix
      telephone
      vat_id
      tag
      customer_notes
    }
  }

  fragment CustomerAddressAttributeFields on CustomerAddressAttribute {
    attribute_code
    value
  }
`

export const UpdateAddress = async (values: any, id: number) => {
  const isExistUser = await getCookieToken()
  if (!isExistUser) return { status: 'error', message: "The current customer isn't authorized." }
  try {
    const response = await fetchWithToken({
      query: UPDATE_ADDRESS,
      variables: {
        addressId: id,
        input: values,
      },
    }).then((res) => res?.payload)
    const token = response?.data?.updateCustomerAddress
    if (!token) return { status: 'error', message: response?.errors?.[0]?.message }
    // revalidateTag('customer-info')
    return { status: 'success', data: 'Address added successfully' }
  } catch (err) {
    return { status: 'error', message: "something's wrong" }
  }
}

export const UpdateCustomerAddress = async ({ values, id }: { values: any; id: string }) => {
  try {
    const response = await fetchWithToken({
      query: UPDATE_CUSTOMER_ADDRESS,
      variables: {
        id: id,
        input: values,
      },
    }).then((res) => res?.payload)
    const token = response?.data?.updateCustomerAddress
    if (!token) return { status: 'error', message: response?.errors?.[0]?.message }
    return { status: 'success', data: 'Address added successfully' }
  } catch (err) {
    return { status: 'error', message: "something's wrong" }
  }
}
